(function () {
  if (window.CardQuickAddInit) return;
  window.CardQuickAddInit = true;

  function parseVariants(card) {
    try {
      return JSON.parse(card.dataset.variants);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(card) {
    const groups = [...card.querySelectorAll('[data-option-group]')];
    return groups.map((group) => {
      const checked = group.querySelector('[data-option-input]:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariantByOptions(variants, selectedOptions) {
    return variants.find((variant) => {
      return selectedOptions.every((value, index) => {
        const variantValue = variant.options[index];
        return value === variantValue;
      });
    }) || null;
  }

  function isValueAvailableForGroup(variants, selectedOptions, groupIndex, candidateValue) {
    const testSelection = [...selectedOptions];
    testSelection[groupIndex] = candidateValue;

    return variants.some((variant) => {
      if (!variant.available) return false;

      return testSelection.every((value, index) => {
        if (!value) return true;
        return variant.options[index] === value;
      });
    });
  }

  function updateOptionAvailability(card) {
    const variants = parseVariants(card);
    const selectedOptions = getSelectedOptions(card);
    const groups = [...card.querySelectorAll('[data-option-group]')];

    groups.forEach((group, groupIndex) => {
      const inputs = [...group.querySelectorAll('[data-option-input]')];

      inputs.forEach((input) => {
        const available = isValueAvailableForGroup(
          variants,
          selectedOptions,
          groupIndex,
          input.value
        );

        input.disabled = !available;

        const pill = input.closest('.card-option-pill');
        if (pill) {
          pill.classList.toggle('is-disabled', !available);
        }
      });

      const checked = group.querySelector('[data-option-input]:checked');
      if (checked && checked.disabled) {
        checked.checked = false;
        const firstAvailable = inputs.find((input) => !input.disabled);
        if (firstAvailable) firstAvailable.checked = true;
      }

      if (!group.querySelector('[data-option-input]:checked')) {
        const firstAvailable = inputs.find((input) => !input.disabled);
        if (firstAvailable) firstAvailable.checked = true;
      }
    });
  }

  function updateCurrentVariant(card) {
    const variants = parseVariants(card);
    const selectedOptions = getSelectedOptions(card);
    const variant = findVariantByOptions(variants, selectedOptions);

    const form = card.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('.product-variant-id');
    const addBtn = form.querySelector('[data-add-to-cart]');
    const addBtnText = form.querySelector('[data-add-to-cart-text]');

    if (!variant) {
      if (variantInput) variantInput.value = '';
      if (addBtn) addBtn.disabled = true;
      if (addBtnText) addBtnText.textContent = 'UNAVAILABLE';
      card.dataset.currentVariantId = '';
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    card.dataset.currentVariantId = variant.id;

    if (addBtn) addBtn.disabled = !variant.available;
    if (addBtnText) {
      addBtnText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    }
  }

  function updateCard(card) {
    updateOptionAvailability(card);
    updateCurrentVariant(card);
  }

  document.addEventListener('change', function (e) {
    const optionInput = e.target.closest('[data-option-input]');
    if (!optionInput) return;

    const card = optionInput.closest('[data-product-card]');
    if (!card) return;

    updateCard(card);
  });

  document.addEventListener('click', function (e) {
    const minusBtn = e.target.closest('[data-qty-minus]');
    const plusBtn = e.target.closest('[data-qty-plus]');

    if (!minusBtn && !plusBtn) return;

    const card = e.target.closest('[data-product-card]');
    if (!card) return;

    const input = card.querySelector('.card-qty-input');
    if (!input) return;

    let value = parseInt(input.value || '1', 10);
    if (Number.isNaN(value) || value < 1) value = 1;

    if (minusBtn) value = Math.max(1, value - 1);
    if (plusBtn) value = value + 1;

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initCards() {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      updateCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }

  document.addEventListener('shopify:section:load', initCards);
})();